import React from "react";
import Footer from "../components/Footer";
import NewShipmentsGrid from "./Grid";
import CancelButton from "../components/Buttons/CancelButton";
import {
  getDataWithQueryString,
  postData,
} from "./../../../../api/componentAPIs";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import WithDrawer from "../../Dispatch/Common/Drawer/WithDrawer";
import { Button, CircularProgress, withStyles } from "@material-ui/core";
import Events from "../../../../utilities/EventEmitter";
const styles = (theme) => ({
  actionButton: {
    textTransform: "none",
    minWidth : 188,
    minHeight : 36
  },
  circularProgress: {
    color: theme.white,
  },
});
class NewShipments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newShipments: null,
      saveInProgress: false,
    };
    this.gridApi = {};
  }

  componentDidMount() {
    this.getNewShipmentsData();
    Events.on("NewShipmentsDetected", this.getNewShipmentsData);
  }

  componentWillUnmount() {
    Events.off("NewShipmentsDetected", this.getNewShipmentsData);
  }

  getNewShipmentsData = () => {
    const {
      userData: { userProfile },
    } = this.props;
    getDataWithQueryString(
      "GetShipmentsToAdd",
      `terminalId=${userProfile.terminal.id}&terminalCode=${userProfile.terminal.code}&planDate=${userProfile.planDate}&startDate=${userProfile.startDate}`
    ).then(
      (newShipments) => {
        if (newShipments && newShipments.status === 200) {
          this.setState({
            newShipments: newShipments.data,
          });
          this.selectPros();
        } else {
          this.props.enqueueSnackbar("Unable to fetch new shipments", {
            variant: "error",
          });
          this.setState({
            newShipments: [],
          });
        }
      },
      (_error) => {
        this.props.enqueueSnackbar("Unable to fetch new shipments", {
          variant: "error",
        });
        this.setState({
          newShipments: [],
        });
      }
    );
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  selectPros = () => {
    this.gridApi.forEachNode((node) => {
      if (node.data.isInPlan) {
        node.setSelected(true);
      }
    });
  };

  handleError = () => {
    this.props.enqueueSnackbar("Adding shipments to plan failed", {
      variant: "error",
    });
    this.setState({
      saveInProgress: false,
    });
  };

  handleSubmit = () => {
    const selectedShipments = this.gridApi
      .getSelectedRows()
      .filter((pro) => !pro.isInPlan)
      .map((pro) => pro.proId);
    const reqData = {
      pros: selectedShipments,
      planDate: this.props.userData.userProfile.planDate,
      terminalId: this.props.userData.userProfile.terminal.id,
      startDate: this.props.userData.userProfile.startDate ?? undefined
    };
    this.setState({
      saveInProgress: true,
    });
    postData("AddShipmentsToPlan", reqData).then(
      (response) => {
        if (response?.status === 200) {
          this.setState({
            saveInProgress: false,
          });
          this.props.handleCancel();
        } else {
          this.handleError();
        }
      },
      (_error) => {
        this.handleError();
      }
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <NewShipmentsGrid
          rowData={this.state.newShipments}
          onGridReady={this.onGridReady}
          glEventHub={this.props.glEventHub}
          userProfile={this.props.userData.userProfile}
          serviceLevelList={this.props.serviceLevelList}
        />
        <Footer>
          <CancelButton onClick={this.props.handleCancel} />
          <Button
            classes={{
              root: classes.actionButton,
            }}
            variant="contained"
            color="primary"
            onClick={this.handleSubmit}
          >
            {this.state.saveInProgress ? (
              <CircularProgress
                size={16}
                classes={{ root: classes.circularProgress }}
              />
            ) : (
              "Add Shipments to Plan"
            )}
          </Button>
        </Footer>
      </>
    );
  }
}

export default compose(
  WithDrawer,
  withSnackbar,
  withUserProfile,
  withStyles(styles)
)(NewShipments);
